const ANIMATED_ACTIONS = new Set(["replace", "update"])
const TRANSITION_MS = 200

function prefersReducedMotion () {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

function shouldAnimate (targetElement) {
  return targetElement &&
    targetElement.id !== "flashes" &&
    !targetElement.hasAttribute("data-turbo-stream-no-transition")
}

function wait (duration) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, duration)
  })
}

async function animateOut (element) {
  element.classList.add("turbo-stream-transition")

  await new Promise((resolve) => requestAnimationFrame(resolve))
  element.classList.add("is-exiting")

  await Promise.race([
    new Promise((resolve) => {
      const onTransitionEnd = (event) => {
        if (event.target !== element) return

        element.removeEventListener("transitionend", onTransitionEnd)
        resolve()
      }

      element.addEventListener("transitionend", onTransitionEnd)
    }),
    wait(TRANSITION_MS + 50)
  ])
}

function animateIn (element) {
  element.classList.add("turbo-stream-transition", "is-entering")

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      element.classList.remove("is-exiting")
      element.classList.add("is-entered")
    })
  })

  const cleanup = () => {
    element.classList.remove(
      "turbo-stream-transition",
      "is-entering",
      "is-entered",
      "is-exiting"
    )
  }

  element.addEventListener("transitionend", function onTransitionEnd (event) {
    if (event.target !== element) return

    element.removeEventListener("transitionend", onTransitionEnd)
    cleanup()
  })

  window.setTimeout(cleanup, TRANSITION_MS + 50)
}

function installTurboStreamTransitions () {
  document.addEventListener("turbo:before-stream-render", (event) => {
    if (prefersReducedMotion()) return

    const { newStream, render } = event.detail
    const action = newStream.getAttribute("action")

    if (!ANIMATED_ACTIONS.has(action)) return

    const targetId = newStream.getAttribute("target")
    if (!targetId) return

    const targetElement = document.getElementById(targetId)
    if (!shouldAnimate(targetElement)) return

    event.detail.render = async (streamElement) => {
      await animateOut(targetElement)
      await render(streamElement)

      const updatedElement = document.getElementById(targetId)
      if (shouldAnimate(updatedElement)) animateIn(updatedElement)
    }
  })
}

installTurboStreamTransitions()
